<ng-container *ngIf="repo.cityState(); else loading">
<div class="w-full relative flex justify-center items-center text-white" id="hero-image-foreign-hotels">
  <img src="/assets/images/bg-header-iranhotels.webp" height="360" width="100%" alt="هتل های خارجی" />
  <h1 class="absolute">هتل های ایران به تفکیک شهرها</h1>
</div>
<div class="container" id="popular-StatesCitiesRegions">
  <div class="w-full my-8xl" >
    <div class="flex justify-between">
        <h4 class="text-h6 text-gray-ds-400 font-bold">هتل های ایران به تفکیک شهرها</h4>
    </div>
    <div class="grid lg:grid-cols-3 grid-cols-1 gap-lg my-3xl">
<div class="hotel-list__item overflow-hidden relative p-3 bg-white rounded-lg" 
*ngFor="let item of repo.cityState()?.PopularCities">
  <a [href]="item.Url" class="w-100 h-100 flex hotel-link">
    <h3 class="hotel-title absolute top-6 right-4 text-white mr-3">
     {{item.Title}}
    </h3>
    <div class="images position-relative">
      <img [src]="item.Image" [alt]="item.Title"
        class="block w-full rounded-lg h-full" loading="lazy">
    <div
      class="flex float-start justify-center absolute top-6 left-4 z-10 rounded-full items-center text-small px-lg text-error-500 bg-error-100 border border-solid border-error-100">
      <span class="iho-icon-hot-price text-xl"></span>
      <span>تا <b>{{ item.MaxDiscount }}</b>% تخفیف</span>
    </div>

    </div>
  </a>
</div>
      </div>
  </div>
  <div class="w-full my-8xl flex justify-between" id="state-city">
    <div class="flex justify-between">
      <h4 class="text-h6 text-gray-ds-400 font-bold">سایر شهرهای ایران</h4>
    </div>
    <iho-input  [icon]="'ico-Search'" 
    (input)="onSearchCity($event)"
    [type]="'text'"
    [template]="'inline'" [label]="'انتخاب شهر '" [placeholder]="'انتخاب شهر '">
    </iho-input>
    </div>
<div class="w-full">
  <div class="grid lg:grid-cols-4 grid-cols-1 gap-4">
    <div *ngFor="let col of [0,1,2,3]">
      <ng-container *ngFor="let item of filteredStates; let index = index">
        <ng-container *ngIf="index % 4 === col">
          <ng-container *ngTemplateOutlet="column; context: { itemData: item, index: index }"></ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <ng-template #column let-itemData="itemData" let-index="index">
    <div class="rounded border border-gray-ds border-solid mt-4 max-h-72 overflow-hidden">
      <div
        class="rounded-t text-black-900 hover:bg-transparency-primary-10 hover:text-primary-500 flex items-center justify-between transition-all duration-200 p-sm py-4">
        <h5 class="font-bold mr-2">{{ itemData.StateTitle }}</h5>
        <span class="ml-2">({{ itemData.CountHotelsOfState }})</span>
      </div>

      <div class="border-solid border-t border-gray-ds">
        <iho-recursive-destinations [destinations]="itemData.Cities"></iho-recursive-destinations>
      </div>
    </div>

  <div (click)="showMore(index, $event)" *ngIf="itemData.Cities.length > 5"
    class="showMore-{{
       index
      }} w-full cursor-pointer text-small rounded-b hover:bg-transparency-primary-10 text-primary-500 flex justify-center items-center border-solid border border-gray-ds p-2">
    <span>{{ showIcon[index] ? 'بستن' : 'مشاهده بیشتر' }}</span>
    <i class="ico-Down text-2xl" [ngClass]="showIcon[index] ? 'rotate-180' : ''"></i>
  </div>
  </ng-template>
</div>

</div>

</ng-container>


<ng-template #loading>
  <iho-skeleton height="360px" width="100%" />
  <div class="container">
    <div class="w-full my-8xl">
      <iho-skeleton height="1.5rem" width="10rem" class="rounded-full mx-2" />
      <iho-skeleton height="1.5rem" width="20rem" class="rounded-full mx-2" />
    </div>
    <div class="grid lg:grid-cols-4 grid-cols-1 gap-lg my-3xl">
      <div class="card-items rounded-lg border border-solid border-gray-ds w-full h-[350px]"
        *ngFor="let item of [].constructor(4)">
        <iho-skeleton height="350px" width="100%" class="rounded-t-lg h-[192px]" />
      </div>
    </div>
  </div>
</ng-template>